import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { deleteRequest } from "../../../helpers/api.helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

type DeleteModalProps = {
  closeReportModal: () => void;
  profile: any;
  returnTo?: string | null;
};

const DeleteModal = ({
  closeReportModal,
  profile,
  returnTo,
}: DeleteModalProps) => {
  const [reportDescription, setReportDescription] = useState("");
  const [reportLoading, setReportLoading] = useState(false);
  const [reportReason, setReportReason] = useState("");

  const navigate = useNavigate();
  // Submit delete
  const handleDeleteSubmit = async () => {
    if (!reportDescription.trim()) {
      alert("Please provide a reason for deleting");
      return;
    }
    setReportLoading(true);
    try {
      const response = await deleteRequest(
        `/bureau/profile/${profile.martialId}`,
        {
          reason: reportDescription,
        }
      );
      if (response.success) {
        toast.success(response.message || "Profile reported successfully");
        closeReportModal();
        navigate(returnTo || "/admin/dashboard", {
          replace: true,
          state: { deletedProfileId: profile.martialId },
        });
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error deleting profile:", error);
      toast.error("Error reporting profile. Please try again.");
    } finally {
      setReportLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-red-600">Delete Profile</h2>
          <button
            onClick={closeReportModal}
            className="text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
        </div>

        <div className="mb-4 p-3 bg-gray-50 rounded">
          <p className="text-sm text-gray-600">Deleting Profile:</p>
          <p className="font-semibold">{profile.fullName}</p>
          <p className="text-sm text-gray-600">
            Marital ID: {profile.martialId}
          </p>
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Reason for deleting
          </label>
          <textarea
            value={reportDescription}
            onChange={(e) => setReportDescription(e.target.value)}
            placeholder="Please provide more details about your Delete..."
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
            rows={4}
          />
        </div>

        <div className="flex space-x-4">
          <button
            onClick={closeReportModal}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            disabled={reportLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteSubmit}
            disabled={reportLoading || !reportDescription.trim()}
            className="flex-1 py-2 px-4 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            {reportLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Deleting...
              </>
            ) : (
              " Delete Profile"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
